import { render, staticRenderFns } from "./SubstationSavingsChart.vue?vue&type=template&id=4f785718&"
import script from "./SubstationSavingsChart.vue?vue&type=script&lang=js&"
export * from "./SubstationSavingsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports